import { TicketingFormCategory } from "../../enums";
import { OrganizationCountry } from "../enums/country";
export const DEFAULT_TIP_PERCENTAGE_FOR_SMALL_AMOUNTS_BY_ORGANIZATION_COUNTRY = {
    [OrganizationCountry.Canada]: 15,
    [OrganizationCountry.UnitedStates]: 17,
    [OrganizationCountry.GreatBritain]: 15,
    [OrganizationCountry.Australia]: 15,
    [OrganizationCountry.NewZealand]: 15,
    [OrganizationCountry.Ireland]: 15,
    [OrganizationCountry.Germany]: 15,
};
export const hasCanadianTipSuggestion = (organizationCountry) => {
    return organizationCountry === OrganizationCountry.Canada || organizationCountry === OrganizationCountry.Australia;
};
export const hasUnitedStatesTipSuggestion = (organizationCountry) => {
    return organizationCountry === OrganizationCountry.UnitedStates;
};
export const hasGermanTipSuggestion = (organizationCountry, formCategory) => {
    return organizationCountry === OrganizationCountry.Germany && formCategory !== TicketingFormCategory.Auction;
};
